import { Button } from 'common-front/src/designSystem/components/button';
import { Content } from 'common-front/src/designSystem/components/tooltip/content';
import { Tooltip } from 'common-front/src/designSystem/components/tooltip/tooltip';
import { Trigger } from 'common-front/src/designSystem/components/tooltip/trigger';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Flex } from 'common/src/designSystem/components/flex';
import * as React from 'react';

interface IEventMenuTogglerProps {
    isOpen: boolean;

    onToggle(): void;
}

export const EventMenuToggler = (props: IEventMenuTogglerProps) => {
    const { translate } = useHeavent();

    return (
        <Flex align="center" css={{ px: '$4' }} height={48} justify="end">
            <Tooltip>
                <Trigger>
                    <Button
                        color="white"
                        css={{ border: 'none' }}
                        leftIcon="sidebar"
                        size="sm"
                        onClick={props.onToggle}
                    />
                </Trigger>

                <Content placement="top">
                    {props.isOpen
                        ? translate('masquer_le_menu_29008')
                        : translate('afficher_le_men_91936')}
                </Content>
            </Tooltip>
        </Flex>
    );
};
